import { Box } from '@chakra-ui/react';

export const PanelTitle: React.FC = ({ children }) => {
  return (
    <Box color="text.300" fontSize="sm" fontWeight="400" padding="var(--chakra-space-2) var(--chakra-space-4)">
      {children}
    </Box>
  );
};
